import { connect } from "react-redux";
import { contasController, ContasViewProps, mapDispatchToContasProps, mapStateToContasProps } from "../contas.controll";
import { Contas, ContasGroup, initialValueContasState } from "../contas.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, Chip, Grid, Icon, IconButton, Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { ContasCadastro } from "./contas.cad";
import { formatData, formatMoney } from "../../../services/utils";
import { Add, AddCircle, ListAlt } from "@mui/icons-material";
import store from "../../../store";

export const situacaoColorContas = (value: any) => {
    switch (value) {
        case "pago":
            return "success";
        case "aberto":
            return "error"
        default:
            return "warning";
    }
}

const columns: GridColDef[] = [
    { field: 'created_at', headerName: 'Data', flex: 3, renderCell: (prm) => formatData(prm.value) },
    { field: 'pessoa.nome', headerName: 'Nome', flex: 3, valueGetter: (value, row: Contas) => row.pessoa.nome },
    { field: 'valor', headerName: 'Valor', flex: 2, renderCell: (prm) => formatMoney(prm.value) },
    { field: 'situacao', headerName: 'Situacão', flex: 4, renderCell: (prm) => <Chip variant="filled" color={situacaoColorContas(prm.value)} label={prm.value} /> },
]

function ContasList(props: ContasViewProps) {
    const { contasActions, contasState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status, showCadModal, changeList, contasGroup, contaGroup } = contasState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal, setContaGroup, handleNovaConta } = contasActions
    useEffect(() => {
        read()
    }, [])


    const handleAlterar = (row: any) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        setShowCadModal(false)
    }



    const handleSetRowsTipo = (row: ContasGroup) => {
        setContaGroup(row);
    }

    const GridTipoContas = () => {
        return (
            <Grid
                container
                spacing={2}
                columns={12}
                sx={{ mb: (theme) => theme.spacing(2) }}
            >
                {contasGroup.map((rowGr, idx) => (
                    <Grid key={idx} size={{ xs: 12, sm: 6, lg: 3 }}>
                        <Card variant="highlighted" sx={{ height: '100%', flexGrow: 1 }}>
                            <CardHeader
                                avatar={
                                    <IconButton size="small" title="Adicionar nova conta" onClick={() => { }}>
                                        <Add fontSize="small" />
                                    </IconButton>
                                }
                                title={
                                    <Typography variant="subtitle1" component="p">
                                        A {rowGr.tipo}
                                    </Typography>
                                }
                                action={
                                    <Chip color={rowGr.tipo === "Pagar" ? "warning" : rowGr.tipo === "Receber" ? "success" : "info"} label={rowGr.contas.length} />
                                }
                            />
                            <CardContent>
                                <Box sx={{ width: '100%', height: 30 }}>
                                    <Stack flexDirection={"row"} justifyContent={"space-between"}>
                                        <Typography variant="h4" component="p">
                                            {formatMoney(rowGr.contas.map(conta => conta.valor).reduce((a, b) => a + b, 0))}
                                        </Typography>
                                        <IconButton color="secondary" size="small" title="Mostrar as contas" onClick={() => handleSetRowsTipo(rowGr)}>
                                            <ListAlt />
                                        </IconButton>
                                    </Stack>
                                </Box>
                            </CardContent>
                        </Card>

                    </Grid>
                ))}
            </Grid>
        )
    }


    const List = () => {
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={`Contas`}

                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columns}
                rows={contaGroup.contas}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: false,
                    onClick: () => { }
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => read()
                }}
                ListItemTextPrimary={(row: Contas) => <Typography component={"span"}>{row.pessoa.nome}</Typography>}
                ListItemTextSecondary={(row: Contas) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.valor}</Typography>
                        <Typography component={"span"}>{row.situacao}</Typography>
                    </Box>
                }
                ViewBeforeGridList={GridTipoContas}
                hidenGridNoData
            />
        )
    }

    return (
        <div className="modulo">
            <CadastroContas {...props} />
            <List />
        </div>
    )

}

export const handleShowCadContasModal = (set:boolean,id?:string) => {
    store.dispatch(contasController.reducer.actions.setShowCadModal(set));
    if(id)
        store.dispatch(contasController.reducer.actions.get(id));
}

function CadastroContas(props:ContasViewProps) {
    const { showCadModal } = props.contasState
    const handleCloseCadastro = () => {
        handleShowCadContasModal(false)
    }
    return ContasCadastro({
        ...props,
        handleCloseView: handleCloseCadastro ,
    }).renderModal({
        handleClose: handleCloseCadastro,
        show: showCadModal,
        width: "sm",
        heigth: "auto",
    })
}

export const CadastroContasModal = connect(mapStateToContasProps, mapDispatchToContasProps)(CadastroContas);

export default connect(mapStateToContasProps, mapDispatchToContasProps)(ContasList);
